import {NameResolver} from '@/utils/propertyDefinition'
import {EnhancedWorkpace} from '@/types/Workspace'

/**
 * Resolve alias no workspace, para o propertyDefinition.
 *
 * A coleção devolve o nome; a propriedade devolve o objeto inteiro, porque o espelho
 * de um relacionamento tira a cardinalidade e a exclusividade do outro lado, não de si.
 *
 * Mora fora do propertyDefinition de propósito: aquele módulo não conhece o workspace,
 * e é isso que o mantém puro. Mora fora do ViewClass porque a ficha da coleção e o
 * diagrama de classes precisam do mesmo resolvedor.
 */
export function workspaceNames(workspace: EnhancedWorkpace): NameResolver {
    return {
        idea: (alias: string) => {
            const found = workspace.ideaWith(alias)
            return found ? found.name : alias
        },
        property: (ideaAlias: string, propertyAlias: string) => {
            const found = workspace.ideaWith(ideaAlias)
            return found ? found.properties.find(p => p.alias === propertyAlias) : undefined
        },
        domain: (domainAlias: string | undefined) => workspace.domainWith(domainAlias)
    }
}
